/**
 * Zod schemas for the social surface: player search, friends, blocking
 * (docs/APP_PLAN.md §12 M4, APP_SPEC §14–§15).
 *
 * Field naming deliberately matches the target-user field names the
 * cross-user route-registration guard recognizes
 * (`apps/api/src/plugins/cross-user-guard.ts`): `targetUsername`. Reusing
 * the exact field name lets the guard's automatic detection work without
 * a bespoke declaration per route.
 */
import { z } from 'zod';

import { USERNAME_CONSTRAINTS } from '@perplexicon/config';

import { usernameSchema } from './auth.js';
import { paginationQuerySchema } from './pagination.js';

export const targetUsernameRequestSchema = z.object({
  targetUsername: usernameSchema,
});
export type TargetUsernameRequest = z.infer<typeof targetUsernameRequestSchema>;

export const usernameParamsSchema = z.object({
  username: z.string().trim().min(1).max(USERNAME_CONSTRAINTS.maxLength),
});

export const userIdParamsSchema = z.object({
  userId: z.string().min(1),
});

export const searchQuerySchema = paginationQuerySchema.extend({
  q: z
    .string()
    .trim()
    .min(1, 'Enter a username to search for.')
    .max(USERNAME_CONSTRAINTS.maxLength),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;
